import { Component } from '@angular/core';
import { Auth, user } from '@angular/fire/auth';
import { MenuController, NavController } from '@ionic/angular';
import { Observable, combineLatest, filter, map } from 'rxjs';
import { ConfirmAlert } from 'src/app/decorators/confirm-alert-decorator';
import { AuthService } from 'src/app/services/auth.service';
import { ProfileImageOptsNew } from 'src/app/types';

@Component({
  selector: 'me-current-user-item',
  templateUrl: './current-user-item.component.html',
  styleUrls: ['./current-user-item.component.scss'],
})
export class CurrentUserItemComponent {
  profileImageOpts$: Observable<ProfileImageOptsNew> = combineLatest([
    this.$auth.currentEmployee$,
    user(this.auth)
  ]).pipe(
    filter(([currentUser, firebaseUser]) => !!currentUser && !!firebaseUser),
    map(([currentUser, firebaseUser]) => ({
      name: currentUser?.firstName ?? '',
      photoURL: firebaseUser?.photoURL ?? undefined
    }))
  );

  currentEmployeeId$ = this.$auth.currentEmployee$.pipe(
    filter(employee => !!employee),
    map(employee => employee!.id)
  );

  constructor(
    private auth: Auth,
    private $auth: AuthService,
    private navCtrl: NavController,
    private menuCtrl: MenuController
  ) {}

  async goToEmployeeDetails(employeeId: string) {
    try {
      await this.navCtrl.navigateForward(['/employees/details', employeeId]);
    } finally {
      this.menuCtrl.close('mainMenu');
    }
  }

  @ConfirmAlert({
    i18nConfirmButtonKey: 'action.logout',
    i18nMessageKey: 'logout.message',
    i18nTitleKey: 'action.logout',
    i18nCancelButtonKey: 'action.cancel',
  })
  async logout() {
    try {
      await this.$auth.logout();
    } catch (error) {
      console.error('[CurrentUserItemComponent:logout] error signing out', error);
    }
  }
}
